module.exports = __webpack_public_path__ + "Roboto-500.0f3b7101a8adc1afe1fb.woff";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.woff
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.woff
// module chunks = main styles